import {
  Box,
  Button,
  Container,
  Grid,
  makeStyles,
  Typography,
  withStyles
} from '@material-ui/core'
import React, { useEffect, useCallback } from 'react'
import { useLocation } from 'react-router-dom'
import config from '../../Config'
import api from '../../services/Api'
import { Carregando } from '../../components'
import { BRAND } from '../../branding'

const styles = makeStyles(theme => ({
  container: {
    height: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  divider: {
    height: 60,
    marginInline: 16,
    background: 'rgb(255 255 255 / 15%)'
  },
  title: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    color: theme.palette.getContrastText('#263238')
  },
  login: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center'
  },
  button: {
    width: 200
  },
  presentation: {
    marginLeft: theme.spacing(2)
  },
  page: {
    backgroundImage: 'url(/blob.svg)',
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat'
  }
}))

const LoginBase = () => {
  const classes = styles()
  const location = useLocation()

  async function handleLogin() {
    const ssoWebUrl = config.ssoWebUrl
    const grWebUrl = config.grWebUrl
    const ssoClientId = config.ssoClientId

    window.location.assign(
      `${ssoWebUrl}/login?url=${grWebUrl}/callback&clientId=${ssoClientId}`
    )
  }

  const params = new URLSearchParams(location.search)
  const token = params.get('token')

  const loginGr = useCallback(async () => {
    if (token) {
      const response = await api.login({ token })

      if (response.ok) {
        if (response.data.usuario.codigoLotacao) {
          const userGr = {
            id: response.data.usuario.id,
            name: response.data.usuario.nome,
            realm: response.data.usuario.realm,
            centroCusto: response.data.codigoLotacao,
            ok: true,
            token: response.data.token
          }

          localStorage.setItem('user', JSON.stringify(userGr))
          localStorage.setItem('empresa', String(response.data.usuario.empresaId))
        } else {
          alert(
            'Nenhum Centro de Custo definido, entre em contato com a Central de Cadastros para configuração!'
          )
        }
        window.location.href = '/'
      }
    }
  }, [token])

  useEffect(() => {
    loginGr()
  }, [loginGr])

  if (location.pathname === '/callback' && !!token) {
    return <Carregando />
  }

  return (
    <Box
      bgcolor="#263238"
      height="100vh"
      width="100vw"
      className={classes.page}
    >
      <Container className={classes.container}>
        <Grid container spacing={4}>
          <Grid item xs={12} sm={6} className={classes.login}>
            <Box display="flex" justifyContent="center" alignItems="center">
              <img src={BRAND.alternative} alt={BRAND.name} />
            </Box>

            <Typography variant="h4" className={classes.title}>
              Central de Cadastros
            </Typography>

            <Button
              variant="contained"
              color="primary"
              className={classes.button}
              onClick={handleLogin}
            >
              Entrar
            </Button>
          </Grid>

          <Grid item xs={12} sm={6}>
            <img
              src="/presentation.svg"
              alt="Apresentação do Central de Cadastros"
              style={{ width: '100%' }}
            />
          </Grid>
        </Grid>
      </Container>
    </Box>
  )
}

export default withStyles(styles)(LoginBase)
